import { Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'
import { FONTS, SPACES } from 'src/constants'

export const useStyles = makeStyles((theme: Theme) => ({
  sectionWrapper: {
    '&&': {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      width: '100%',

      gap: SPACES.xxxl,
    },
  },
  text: {
    '&&': {
      fontSize: FONTS.SIZES.m,
      fontWeight: FONTS.WEIGHTS.light,
      lineHeight: 1.4,
      textAlign: 'center',

      color: theme.palette.custom.darkBlue2,
    },
  },
  warningText: {
    '&&': {
      color: theme.palette.custom.warning2,
      fontSize: FONTS.SIZES.s,
      lineHeight: 1.4,
    },
  },
  confirmButton: {
    '&&': {
      fontSize: FONTS.SIZES.s,
      textTransform: 'none',
      fontWeight: FONTS.WEIGHTS.bold,
      backgroundColor: theme.palette.custom.warning2,

      '&:disabled': {
        backgroundColor: theme.palette.custom.secondary,
        color: theme.palette.custom.darkBlue2,
      },

      '&:hover, &:focus': {
        backgroundColor: '#d9434b',
      },
    },
  },
}))
